<template>
    <div class="node-properties-inner">
        <label>Minimum</label>
        <input v-model="properties.minimum">
        <label class="units">Km/h</label>

        <label>Maximum</label>
        <input v-model="properties.maximum">
        <label class="units">Km/h</label>
    </div>
</template>

<script>
export default {
    props: {
        properties: { type: Object, required: true }
    }
}
</script>